module.exports = __webpack_public_path__ + "img/climbing-table-icon.37154639.svg";